import { Avatar, Box, IconButton, List, ListItem, ListItemIcon, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { HiOutlinePhone } from "react-icons/hi2";
import { CiMail } from "react-icons/ci";
import { CiGlobe } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ThemeContext } from '../../context/ThemeContext';
import { useNavigate } from 'react-router-dom';

export default function About() {
    const logo = '/logo192.png'
    const {darkMode} = useContext(ThemeContext)
    const navigate = useNavigate();


    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 1, }}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackIosNewIcon fontSize="small" /> 
                </IconButton>
                <Typography sx={{ ml: 1, fontSize: '18px', color: darkMode ? 'white' : 'black' }}>About US</Typography>
            </Box>
            <Box p={1}>
                <Box sx={{ display: 'flex', flexDirection: 'column', my: 1, ml: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'start', backgroundColor: '#000', width: "45px", my: 2, mb: 3 }}>
                        <Avatar src={logo} alt="Logo" sx={{ width: 45, height: 45, }} />
                    </Box>
                    <Typography fontWeight={600} fontSize={18}>{process.env.REACT_APP_COMPANY_NAME}</Typography>
                </Box>

                <List disablePadding sx={{ backgroundColor: '#fff' }}>
                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                            <HiOutlinePhone style={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <Box>
                            <Typography fontSize={12} color="gray">Phone Number</Typography>
                            <Typography fontWeight={600} fontSize={14}>{process.env.REACT_APP_CONTACT_NUMBER}</Typography>
                        </Box>
                    </ListItem>

                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                            <CiMail style={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <Box>
                            <Typography fontSize={12} color="gray">Email ID</Typography>
                            <Typography fontWeight={500} fontSize={14}>{process.env.REACT_APP_COMPANY_EMAIL}</Typography>
                        </Box>
                    </ListItem>

                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                            <CiGlobe style={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <Box>
                            <Typography fontSize={12} color="gray">Website</Typography>
                            <Typography fontWeight={500} fontSize={14}>{process.env.REACT_APP_COMPANY_WEBSITE}</Typography>
                        </Box>
                    </ListItem>

                    <ListItem sx={{ alignItems: 'flex-start' }}>
                        <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                            <CiLocationOn style={{ fontSize: 20 }} />
                        </ListItemIcon>
                        <Box>
                            <Typography fontSize={12} color="gray">Location</Typography>
                            <Typography fontWeight={500} fontSize={14}>
                                {process.env.REACT_APP_ADDRESS}
                            </Typography>
                        </Box>
                    </ListItem>
                </List>

            </Box>
        </>
    )
}
